import React from 'react';
import { useTranslation } from 'react-i18next';
import './Contact.css';

const Contact = () => {
    const { t } = useTranslation();

    return (
        <div className="contact-page">
            <section className="contact-hero">
                <div className="container">
                    <div className="hero-content">
                        <h1 className="section-title" style={{ textAlign: 'center' }}>
                            {t('contact.pageTitle')}
                        </h1>
                        <p className="hero-subtitle">
                            {t('contact.pageSubtitle')}
                        </p>
                    </div>
                </div>
            </section>

            <section className="contact-content">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="contact-info-list">
                                <div className="contact-item">
                                    <div className="contact-icon">
                                        <i className="fas fa-map-marker-alt"></i>
                                    </div>
                                    <div className="contact-details">
                                        <h3>{t('home.contact.addressLabel')}</h3>
                                        <p>{t('home.contact.location')}</p>
                                    </div>
                                </div>

                                <div className="contact-item">
                                    <div className="contact-icon">
                                        <i className="fas fa-phone"></i>
                                    </div>
                                    <div className="contact-details">
                                        <h3>{t('home.contact.phoneLabel')}</h3>
                                        <a href={`tel:+973${t('home.contact.phone')}`} dir="ltr">
                                            +973 {t('home.contact.phone')}
                                        </a>
                                    </div>
                                </div>

                                <div className="contact-item">
                                    <div className="contact-icon">
                                        <i className="fas fa-envelope"></i>
                                    </div>
                                    <div className="contact-details">
                                        <h3>{t('home.contact.emailLabel')}</h3>
                                        <a href={`mailto:${t('home.contact.email')}`}>
                                            {t('home.contact.email')}
                                        </a>
                                    </div>
                                </div>

                                <div className="contact-item">
                                    <div className="contact-icon">
                                        <i className="fas fa-clock"></i>
                                    </div>
                                    <div className="contact-details">
                                        <h3>{t('home.contact.hoursLabel')}</h3>
                                        <p>{t('home.contact.available247')}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="social-section">
                                <h3>{t('contact.followUs')}</h3>
                                <div className="social-links">
                                    <a
                                        href="https://web.facebook.com/people/Dr-Hasan-Haji-Medical-Center/100037144988616"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fab fa-facebook-f"></i>
                                        <span>Facebook</span>
                                    </a>
                                    <a
                                        href="https://instagram.com/drhasanhaji"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fab fa-instagram"></i>
                                        <span>Instagram</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-12">
                            <div className="map-section">
                                <div className="map-container">
                                    <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3638.2655034852883!2d50.61469541504632!3d26.264392879256633!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49a6158c776dfb%3A0xe265e7a5203fc1b8!2z2YXYsdmD2LIg2KfZhNiv2YPYqtmI2LEg2K3Ys9mGINit2KfYrNmK!5e0!3m2!1sen!2sbh!4v1700000000000!5m2!1sen!2sbh"                                        width="100%"
                                        height="450"
                                        style={{ border: 0 }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        title={t('home.contact.mapLabel')}
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;
